export const STORAGE_KEYS = {
  DELIGHTED_SURVEY_COMPLETED: 'isDelightedSurveyCompleted',
};
